module.exports = __webpack_public_path__ + "img/ai11@2x@2xb.9f2303cb.png";